import { I18N } from '.';

export const fi = {
  loginWith: 'Kirjaudu sisään',
  approveWith: 'Hyväksy',
  signWith: 'Allekirjoita',
  confirmWith: 'Vahvista',
  acceptWith: 'Hyväksy',
  sameDevice: 'Tällä laitteella',
  anotherDevice: 'Henkilötunnuksellasi',
  anotherDeviceQR: 'Toisella laitteella',
  mitidBusiness: 'MitID Businessilla',
  finnishMobileID: 'Suomalaisella Mobiilivarmenteella',
  finnishBankID: 'Suomalaisella BankID:llä',
  swedishBankID: 'Ruotsalaisella BankID:llä',
  norwegianBankID: 'Norjalaisella BankID:llä',
  biometrics: 'Biometrisella tunnistautumisella',
  openAndScan: 'Avaa BankID-sovellus mobiililaitteellasi ja skannaa QR-koodi.',
  thisIsTheQR: 'Tämä on BankID-QR-koodi. Voit napsauttaa sitä nähdäksesi sen koko näytöllä',
  completingLogin: 'Sisäänkirjautumista viimeistellään.',
} satisfies I18N;
